import { Component, OnInit } from '@angular/core';
import { RefundApproveService } from "../Service/refund-approve.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-refund-status',
  templateUrl: './refund-status.component.html',
  styleUrls: ['./refund-status.component.css'],
  providers: [RefundApproveService]
})
export class RefundStatusComponent implements OnInit {

  chaseOrderId: string;
  private sub: any;

  orderId: any;
  invoiceId: any;
  transactionId: any;
  refundAmount: any;
  agency: any;
  advertiser: any;

  constructor(private router: Router, private route: ActivatedRoute, private refundApproveService: RefundApproveService) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
       this.chaseOrderId = params['chaseOrderId']; 
      
       this.refundApproveService.getChaseRefundStatus(this.chaseOrderId)
            .subscribe(
              p => {
                this.orderId = p.orderId;
                this.invoiceId = p.invoiceId;
                this.transactionId = p.transactionId;
                this.refundAmount = p.refundAmount;
                this.agency = p.agency;
                this.advertiser = p.advertiser;
              }
            );

    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  back() {
    this.router.navigate(['RefundApprove']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>MediaPay - Refund Payment</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/refund-approve/refund-status/refund-status.component.ts